/*eslint no-magic-numbers: "off"*/

let config = {
  SADUKA_URL: '//cityads.com',
  HOST: '0.0.0.0',
  PORT: 5000,
  AUTH_URL: 'https://auth2.cityads.com',
  AUTH_APP_ID: 'cityads_v3',
  STAT_URL: 'https://cityads.com/stat',
  NEWS_URL: 'https://cityads.com',
  HIGHLOAD_URL: 'https://cityads.com',
  FIRANO_URL: 'https://firano.cityads.com',
  API_FIRANO_URL: 'https://api.firano.ru',
  AGENTA_IFRAME_URL: 'https://agenta.cityads.com',
  AUTH_STORAGE_COOKIE_NAME: 'storage_key_manager',
  RECAPTCHA_KEY: '6LcdH24UAAAAAJAchRwVOPNV_f1Wp5buju8Mm0pB',
  RECAPTCHA_IGNORE: false,
  SWAGGER_URL: '/saduka/apiDoc/get?lang={LANGUAGE}',
  BACKEND_FETCH_TIMEOUT: 2000,
  NEED_SADUKA_AUTH_UPDATE_TIMEOUT: 1000,

  SUPPORT_LINK: 'mailto:support@cityads.com',

  DEFAULT_LANGUAGE: 'en',

  FB_APP_ID: 253034864852363,
  VK_APP_ID: 3962554,
  ADFOX_OWNER_ID: 275358,

  SUBACCOUNT_MAX_LENGTH: 60,
  SUBACCOUNT_MAX_SUBACCOUNTS: 5,

  FILTER_TOTAL_REQUEST_TIMEOUT: 600,
  FILTER_TOTAL_SHOW_TIME: 8000,
  FILTER_MANY_ITEMS_SLICE: 8,
  PAGE_LIMIT_KEYS: [5, 10, 20, 50],
  PAGE_DEFAULT_LIMIT: 20,
  PAGE_PAGINATION_DISPLAY_COUNT: 8,

  RATING_STAR_COUNT: 5,
  KEYBOARD_TIMEOUT: 500,
  TOOLTIP_DELAY: 500,
  SNACKBAR_AUTOHIDE_DURATION: 5000,
  SELECTED_FILTER_ITEMS_COLLAPSE: 3,
  FILTER_WRAPPER_SLICE_SELECTED: 5,

  MOBILE_SWIPE_AREA_WIDTH: 20,

  DEBUG: false,
  REDUX_LOGGER: false,
  USE_MOCK: false,
  IS_CRISIS: false,

  USE_SADUKA_TRANSPORT: true,
  SADUKA_TRANSPORT_URL: '/sadukatransport',

  FEATURE_SUGGEST_OFFER_ENABLE: true,

  REDMINE_SCRIPT_URL: 'https://redmine.cityads.com/helpdesk_widget/widget.js',
};

try {
  const configLocal = require('cityads-v3/config.local.js');
  if (configLocal) {
    config = {
      ...config,
      ...configLocal.default
    }
  }
} catch (e) { }

try {
  const REACT_APP = /^REACT_APP_/i;
  Object.keys(process.env)
    .filter(key => REACT_APP.test(key))
    .forEach(key => {
      let value = process.env[key];
      if (value === 'false') {
        value = false;
      }
      config[key.replace('REACT_APP_CONFIG_', '')] = value;
    })
} catch (e) { }

if (window && window.__ENV__) {

  Object.keys(window.__ENV__)
    .filter(k => window.__ENV__[k] && k.indexOf('REACT_APP_CONFIG_') === 0)
    .forEach(k => {
      let value = window.__ENV__[k];
      if (value === 'false') {
        value = false;
      }
      config[k.replace('REACT_APP_CONFIG_', '')] = value;
    });

} else {

  if (process.env.REACT_APP_CONFIG_SADUKA_URL_BACKEND) {
    config = {
      ...config,
      SADUKA_URL: process.env.REACT_APP_CONFIG_SADUKA_URL_BACKEND,
      REACT_APP_CONFIG_SADUKA_URL: process.env.REACT_APP_CONFIG_SADUKA_URL_BACKEND
    }
  }

  if (process.env.REACT_APP_CONFIG_AUTH_URL_BACKEND) {
    config = {
      ...config,
      AUTH_URL: process.env.REACT_APP_CONFIG_AUTH_URL_BACKEND,
      REACT_APP_CONFIG_AUTH_URL: process.env.REACT_APP_CONFIG_AUTH_URL_BACKEND
    }
  }

  if (process.env.REACT_APP_CONFIG_DEBUG) {
    config = {
      ...config,
      DEBUG: process.env.REACT_APP_CONFIG_DEBUG
    }
  }



}

export default config;
